export default {
  nav: {
    home: "Головна",
    services: "Послуги",
    about: "Про нас",
    contact: "Контакти",
    book: "Замовити",
  },
  hero: {
    badge: "Засн. 2012 — Понад 3,800 клієнтів",
    line1: "Чистий простір,",
    line2: "Чистий розум.",
    sub: "Професійне прибирання для домів і бізнесу — з точністю, турботою та увагою до деталей.",
    btn1: "Замовити прибирання",
    btn2: "Наші послуги",
    scroll: "Прокрутити",
  },
  partners: "Наші партнери",
  stats: {
    exp: "Років досвіду",
    clients: "Обслужених клієнтів",
    satisfaction: "Рівень задоволеності",
    support: "Підтримка",
  },
  services: {
    pageTitle: "Наші послуги — Cleaning Holding",
    pageMeta: "Ознайомтесь з повним спектром послуг Cleaning Holding.",
    pageSubtitle:
      "Кожна послуга виконується з однаковою відданістю якості — точно, ретельно та індивідуально.",
    label: "Що ми пропонуємо",
    title: "Наші послуги",
    ctaTitle: "Готові розпочати?",
    ctaSub: "Зв'яжіться з нами для безкоштовної консультації.",
    ctaBtn: "Запросити консультацію",
    learnMore: "Детальніше",
    viewAll: "Всі послуги",
    residential: {
      title: "Прибирання житла",
      subtitle: "Ваш дім — бездоганний",
      desc: "Преміум прибирання вдома за вашим розкладом.",
      fullDesc:
        "Ми ставимось до кожного будинку як до свого. Наші фахівці використовують екологічно чисті засоби преміум класу.",
      f1: "Регулярне прибирання",
      f2: "Прибирання кожної кімнати",
      f3: "Санітарія кухні та ванної",
      f4: "Полірування вікон і поверхонь",
    },
    commercial: {
      title: "Комерційне прибирання",
      subtitle: "Простори, що надихають",
      desc: "Прибирання офісів і об'єктів високого класу.",
      fullDesc:
        "Перше враження важливе. Ми підтримуємо бездоганну чистоту в офісах, торгових приміщеннях та об'єктах.",
      f1: "Прибирання офісу",
      f2: "Прибирання торгових приміщень",
      f3: "Прибирання після заходів",
      f4: "Регулярне обслуговування об'єктів",
    },
    deep: {
      title: "Генеральне прибирання",
      subtitle: "Від підлоги до стелі",
      desc: "Ретельне прибирання від підлоги до стелі.",
      fullDesc:
        "Коли звичайного прибирання недостатньо. Наше генеральне прибирання охоплює кожен кут і поверхню.",
      f1: "Повне прибирання об'єкта",
      f2: "Чистка побутової техніки",
      f3: "Відновлення затирки плитки",
      f4: "Чистка вентиляції",
    },
    move: {
      title: "Прибирання при переїзді",
      subtitle: "Чистий старт і фінал",
      desc: "Чистий старт або чистий фінал.",
      fullDesc:
        "Переїзд сам по собі стресовий. Довірте прибирання нам, щоб зосередитися на головному.",
      f1: "Повна санітарія",
      f2: "Чистка шаф і ящиків",
      f3: "Видалення плям зі стін",
      f4: "Прибирання для здачі орендодавцю",
    },
    construction: {
      title: "Постбудівельне прибирання",
      subtitle: "Відкрийте приховану красу",
      desc: "Спеціалізоване постбудівельне прибирання.",
      fullDesc:
        "Після будівництва залишається пил, сміття та залишки матеріалів. Ми перетворюємо будмайданчик на готове житло.",
      f1: "Видалення пилу і сміття",
      f2: "Полірування поверхонь і підлог",
      f3: "Миття вікон і скла",
      f4: "Фінальна перевірка",
    },
    recurring: {
      title: "Регулярні пакети",
      subtitle: "Стабільна досконалість",
      desc: "Щотижневі, двотижневі та щомісячні пакети.",
      fullDesc:
        "Підтримуйте стандарт. Наші пакети гарантують, що ваш простір завжди готовий до прийому гостей.",
      f1: "Щотижня / раз на 2 тиж. / щомісяця",
      f2: "Виділена команда",
      f3: "Індивідуальний чек-лист",
      f4: "Пріоритетний розклад",
    },
  },
  process: {
    label: "Як це працює",
    title: "Наш процес",
    step1: {
      title: "Онлайн-бронювання",
      desc: "Оберіть послугу та зручну дату за кілька хвилин.",
    },
    step2: {
      title: "Ми підтверджуємо",
      desc: "Наша команда розгляне та підтвердить бронювання протягом 2 годин.",
    },
    step3: {
      title: "Ми прибираємо",
      desc: "Навчені фахівці приїдуть вчасно з усім обладнанням.",
    },
    step4: {
      title: "Насолоджуйтесь",
      desc: "Огляньте результат і насолоджуйтесь чистотою.",
    },
  },
  cta: {
    title: "Готові до чистоти?",
    sub: "Отримайте безкоштовну консультацію сьогодні.",
    btn: "Безкоштовна консультація",
  },
  about: {
    pageTitle: "Про нас — Cleaning Holding",
    pageMeta: "Дізнайтесь про Cleaning Holding — 12 років преміум прибирання.",
    label: "Наша історія",
    title: "Про нас",
    subtitle:
      "Десятиліття відданості, тисячі задоволених клієнтів і один незмінний стандарт — досконалість.",
    since: "З 2012 року",
    storyTitle: "Побудовано на довірі",
    story1:
      "Cleaning Holding була заснована у 2012 році з простою, але потужною ідеєю: кожен простір заслуговує на турботу та точність. Починаючи як невелика компанія з прибирання житла, ми виросли у повноцінну сервісну компанію, якій довіряють тисячі домів і підприємств.",
    story2:
      "За останні 12 років ми створили репутацію надійності, дискретності та незмінної відданості якості. Наші клієнти не просто наймають нас — вони нам довіряють.",
    quote:
      "Ми не просто прибираємо простір — ми повертаємо відчуття спокою, порядку і гордості в кожне середовище.",
    valuesLabel: "Що нас рухає",
    valuesTitle: "Наші цінності",
    teamLabel: "Люди за досконалістю",
    teamTitle: "Познайомтесь з командою",
    ctaTitle: "Давайте працювати разом",
    ctaSub: "Відчуйте різницю Cleaning Holding на першому ж сервісі.",
    ctaBtn: "Зв'язатися з нами",
    values: {
      v1: {
        title: "Преміум якість",
        desc: "Використовуємо лише найкращі еко-сертифіковані продукти та суворий контроль якості.",
      },
      v2: {
        title: "Довіра та чесність",
        desc: "Повністю перевірені, застраховані професіонали, яким можна довіряти.",
      },
      v3: {
        title: "Надійність",
        desc: "Вчасно, кожного разу. Ми поважаємо ваш розклад і забезпечуємо стабільні результати.",
      },
      v4: {
        title: "Екологічність",
        desc: "Стійкі рішення для прибирання, що захищають вашу сім'ю, домашніх тварин і навколишнє середовище.",
      },
    },
    team: { exp: "досвіду" },
  },
  contact: {
    pageTitle: "Контакти — Cleaning Holding",
    pageMeta: "Зв'яжіться з Cleaning Holding для безкоштовної консультації.",
    label: "Зв'яжіться з нами",
    title: "Контакти",
    subtitle:
      "Готові до чистоти? Напишіть нам і ми відповімо протягом 2 годин з безкоштовною оцінкою.",
    formTitle: "Надіслати повідомлення",
    formSub: "Відповімо протягом 2 робочих годин.",
    name: "Повне ім'я",
    email: "Ел. пошта",
    phone: "Номер телефону",
    service: "Потрібна послуга",
    message: "Повідомлення",
    selectService: "Оберіть послугу...",
    send: "Надіслати",
    successTitle: "Дякуємо!",
    successMsg:
      "Ваше повідомлення отримано. Наш фахівець зв'яжеться з вами найближчим часом.",
    infoTitle: "Контактна інформація",
    infoSub: "Завжди раді вас чути.",
    whyTitle: "Чому ми",
    why1: "Безкоштовна консультація та оцінка",
    why2: "Відповідь протягом 2 годин",
    why3: "Повністю застрахована команда",
    why4: "Гнучкий розклад",
    address: "Адреса",
    phoneLabel: "Телефон",
    emailLabel: "Ел. пошта",
    hoursLabel: "Робочі години",
    services: {
      residential: "dasuptaveba, Прибирання житла",
      commercial: "dalageba, Комерційне прибирання",
      deep: "Генеральне прибирання",
      moveinout: "Прибирання при переїзді",
      postconstruction: "Постбудівельне прибирання",
      recurring: "Регулярний пакет",
    },
  },
};
